export { default } from './BoardSquare';
